module.exports = {"id":"199378","name":"Mathieu Duhamel","rating":"72","photo":"./data/images/photos/2/199378.png","club":{"name":"Foggia","logo":"./data/images/clubs/Foggia.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MathieuDuhamel0.json
// module id = 2867
// module chunks = 0